(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-hover-preview"] && !Shopify.designMode) return;
  try {
    class CartHoverPreview extends HTMLElement {
    connectedCallback() {
      this.addEventListener('mouseenter', this.refresh.bind(this), { once: false });
      this.addEventListener('focusin', this.refresh.bind(this), { once: false });
      this.addEventListener('click', this.removeItem.bind(this));
    }

    async removeItem(event) {
      const removeLink = event.target.closest('[data-preview-remove]');
      if (!removeLink) return;
      event.preventDefault();

      try {
        const response = await fetch(`${this.dataset.cartUrl}/change.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: removeLink.dataset.lineKey, quantity: 0 }),
        });
        if (response.ok) window.location.href = this.dataset.cartUrl;
      } catch (error) {
        window.location.href = removeLink.href;
      }
    }

    async refresh() {
      if (this.refreshing) return;
      this.refreshing = true;

      try {
        const response = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        this.renderCart(await response.json());
      } catch (error) {
        return;
      } finally {
        this.refreshing = false;
      }
    }

    renderCart(cart) {
      const items = this.querySelector('[data-preview-items]');
      const total = this.querySelector('[data-preview-total]');
      const checkout = this.querySelector('.cart-hover-preview__checkout');
      if (!items || !total || !checkout) return;

      items.innerHTML = cart.items.length
        ? cart.items.map((item) => this.itemMarkup(item)).join('')
        : `<p class="cart-hover-preview__empty">${this.escape(this.dataset.emptyLabel)}</p>`;
      total.textContent = this.formatMoney(cart.total_price);
      checkout.disabled = cart.item_count === 0;
    }

    itemMarkup(item) {
      const image = item.image
        ? `<a href="${this.escape(item.url)}" class="cart-hover-preview__image-link" tabindex="-1" aria-hidden="true"><img src="${this.escape(item.image)}" alt="${this.escape(item.title)}" width="56" height="56" loading="lazy"></a>`
        : '';
      const removeUrl = `${this.dataset.cartUrl}/change?id=${encodeURIComponent(item.key)}&quantity=0`;
      return `<div class="cart-hover-preview__item" data-preview-item>${image}<div class="cart-hover-preview__details"><a href="${this.escape(item.url)}" class="cart-hover-preview__name">${this.escape(item.product_title)}</a><span class="cart-hover-preview__quantity">${item.quantity} × ${this.formatMoney(item.final_price)}</span></div><a href="${removeUrl}" class="cart-hover-preview__remove" data-preview-remove data-line-key="${this.escape(item.key)}" aria-label="${this.escape(this.dataset.removeLabel)}">${this.escape(this.dataset.removeLabel)}</a></div>`;
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, this.dataset.moneyFormat);
      }
      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    }

    escape(value) {
      return String(value ?? '').replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[character]);
    }
  }

  if (!customElements.get('cart-hover-preview')) customElements.define('cart-hover-preview', CartHoverPreview);
  } catch(e) { console.error(e); }
})();

})();
